import React, { useContext, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useTranslate from '../hooks/useTranslate';
import loginIcons from '../assest/signin.gif'
import { useNavigate } from 'react-router-dom';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import Context from '../context';
import { viewUserProfile } from '../store/userSlice';
import { setCookie } from '../common/cookieHelper';

const Login = () => {
    const [data, setData] = useState({
        mobile: "",
        otp: new Array(4).fill("")
    })
    const [otpSent, setOtpSent] = useState(false)
    const [timer, setTimer] = useState(60)
    const [canResend, setCanResend] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { fetchUserDetails, fetchUserAddToCart } = useContext(Context)
    const t = useTranslate({
        empowering: "Empowering",
        indianFarmers: "Indian Farmers",
        withTechnology: "with Technology.",
        joinFarmers: "Join thousands of farmers getting premium agricultural products delivered directly to their doorstep.",
        happyFarmersCount: "1M+",
        happyFarmers: "Happy Farmers",
        productsCount: "5000+",
        products: "Products",
        loginAccount: "Login Account",
        verifyMobile: "Verify Mobile",
        enterMobileDesc: "Enter your mobile number to access your account",
        enterOtpDesc: "Please enter the 4-digit code sent to +91",
        mobileNumber: "Mobile Number",
        enterMobilePlaceholder: "Enter mobile number",
        otpVerification: "OTP Verification",
        resendOtp: "Resend OTP",
        resendIn: "Resend code in",
        verifyLoginBtn: "Verify & Login",
        sendOtpBtn: "Send OTP",
        wrongNumber: "Used wrong number?",
        changeNumber: "Change Number",
        validMobileErr: "Please enter a valid 10-digit mobile number",
        validOtpErr: "Please enter valid 4-digit OTP",
        accountNotApproved: "Your account is not approved yet. Please contact the administrator.",
        loginSuccess: "Login successfully",
        loginFailed: "Login failed",
        verificationFailed: "Verification failed. Try again.",
        failedToFetch: "Failed to fetch. Check your connection.",
        brandFirst: "Fasal",
        brandSecond: "Shop"
    });

    useEffect(() => {
        let interval;
        if (otpSent && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setCanResend(true);
        }
        return () => clearInterval(interval);
    }, [otpSent, timer]);

    const handleOnChange = (e) => {
        const { name, value } = e.target
        if (name === "mobile" && value !== "" && !/^\d+$/.test(value)) return;

        setData((preve) => {
            return {
                ...preve,
                [name]: value
            }
        })
    }

    const handleOtpChange = (element, index) => {
        if (element.value !== "" && !/^\d+$/.test(element.value)) return false;

        setData((prev) => {
            const newOtp = [...prev.otp];
            newOtp[index] = element.value;
            return { ...prev, otp: newOtp };
        });

        // Focus next input
        if (element.nextSibling && element.value !== "") {
            element.nextSibling.focus();
        }
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (data.otp[index] === "" && e.target.previousSibling) {
                e.target.previousSibling.focus();
            }
        }
    }

    const handleSendOtp = async (e) => {
        if (e) e.preventDefault()
        if (!data.mobile || data.mobile.length !== 10) {
            toast.error(t.validMobileErr)
            return
        }

        try {

            const formdata = new FormData()
            formdata.append("phone", data.mobile)
            const dataResponse = await fetch(SummaryApi.sendOtp.url, {
                method: SummaryApi.sendOtp.method,
                body: formdata
            })

            const dataApi = await dataResponse.json()

            if (dataApi.success) {
                toast.success(dataApi.message)
                setOtpSent(true)
                setTimer(60)
                setCanResend(false)
            } else {
                toast.error(dataApi.message)
            }
        } catch (error) {
            console.error("Fetch error:", error)
            toast.error(t.failedToFetch)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const finalOtp = data.otp.join("")
        if (finalOtp.length < 4) {
            toast.error(t.validOtpErr)
            return
        }

        try {
            const formdata = new FormData()
            formdata.append("phone", data.mobile)
            formdata.append("otp", finalOtp)
            formdata.append("device_token", "device_token")
            const dataResponse = await fetch(SummaryApi.verifyOtp.url, {
                method: SummaryApi.verifyOtp.method,
                // credentials: 'include',
                // headers: {
                // "content-type": "application/json"
                // },
                body: formdata
            })

            const dataApi = await dataResponse.json()

            if (dataApi.success === 'true') {
                //approved user
                setCookie('token', dataApi.token, 7)
                setCookie('user_id', dataApi.user_id, 7)
                // Also save to localStorage so global fetch interceptor (index.js) sends actual token
                localStorage.setItem('token', dataApi.token)
                localStorage.setItem('user_id', dataApi.user_id)

                if (dataApi.user_status === "0") {
                    toast.error(t.accountNotApproved);
                    navigate('/sign-up', { state: { mobile: data.mobile } })
                    return;
                }



                toast.success(dataApi.extraData || t.loginSuccess)

                try {
                    const userAction = await dispatch(viewUserProfile())
                    if (viewUserProfile.fulfilled.match(userAction)) {
                        const userPayload = userAction.payload;
                        setCookie('user_info', JSON.stringify(userPayload), 7)
                    }
                } catch (err) {
                    console.error("Profile fetch failed", err)
                }

                fetchUserDetails()
                fetchUserAddToCart()
                navigate('/')
            } else {
                toast.error(dataApi.message || t.loginFailed)
            }
        } catch (error) {
            console.error("Fetch error:", error)
            toast.error(t.verificationFailed)
        }

    }



    return (
        <section id='login' className="bg-white flex min-h-[calc(100vh-140px)] md:min-h-[calc(100vh-180px)] w-full">
            {/* LEFT SIDE: BRANDING/IMAGE (Hidden on mobile/tablet, visible on desktop) */}
            <div className="hidden lg:flex w-1/2 bg-[#143d2c] relative items-center justify-center p-12 lg:p-20 overflow-hidden text-left">
                <div className="absolute top-0 left-0 w-full h-full opacity-10">
                    <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-[#00b259] rounded-full blur-[120px]"></div>
                    <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-[#f39200] rounded-full blur-[100px]"></div>
                </div>

                <div className="relative z-10 max-w-lg text-white w-full">
                    <div className='mb-10'>
                        <img
                            src='/fasalshop.png'
                            alt='FasalShop'
                            className='h-20 w-auto object-contain'
                        />
                    </div>

                    <h2 className="text-5xl text-white font-extrabold leading-[1.1] mb-6">
                        {t.empowering} <span className="text-[#00b259]">{t.indianFarmers}</span> {t.withTechnology}
                    </h2>
                    <p className="text-white/70 text-lg font-medium leading-relaxed mb-10">
                        {t.joinFarmers}
                    </p>

                    <div className="grid grid-cols-2 gap-8 pt-10 border-t border-white/10">
                        <div>
                            <p className="text-3xl font-black text-[#f39200]">{t.happyFarmersCount}</p>
                            <p className="text-sm font-bold text-white/50 uppercase tracking-widest text-[#f39200]">{t.happyFarmers}</p>
                        </div>
                        <div>
                            <p className="text-3xl font-black text-[#00b259]">{t.productsCount}</p>
                            <p className="text-sm font-bold text-white/50 uppercase tracking-widest text-[#00b259]">{t.products}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* RIGHT SIDE: LOGIN FORM */}
            <div className="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-10 lg:p-20 bg-slate-50/50">
                <div className="w-full max-w-md bg-white p-6 sm:p-10 lg:p-14 rounded-[32px] sm:rounded-[40px] shadow-2xl shadow-green-900/5 border border-white">
                    <div className="lg:hidden mb-8 flex justify-center">
                        <img
                            src='/fasalshop.png'
                            alt='FasalShop'
                            className='h-14 w-auto object-contain'
                        />
                    </div>

                    <div className="mb-10 text-center lg:text-left">
                        <h3 className="text-3xl font-black text-slate-800 mb-2">
                            {otpSent ? t.verifyMobile : t.loginAccount}
                        </h3>
                        <p className="text-slate-400 font-medium">
                            {otpSent ? `${t.enterOtpDesc} ${data.mobile}` : t.enterMobileDesc}
                        </p>
                    </div>

                    <form className="flex flex-col gap-6" onSubmit={otpSent ? handleSubmit : handleSendOtp}>
                        <div className="flex flex-col gap-2 text-left">
                            <label className="text-xs font-black uppercase tracking-[2px] text-slate-400 ml-1">{t.mobileNumber}</label>
                            <div className="group flex items-center bg-slate-100/80 border-2 border-transparent focus-within:border-[#00b259] focus-within:bg-white rounded-[20px] px-6 py-5 transition-all shadow-sm">
                                <span className="text-lg font-bold text-slate-400 border-r-2 border-slate-200 pr-4 mr-4">+91</span>
                                <input
                                    type="text"
                                    placeholder={t.enterMobilePlaceholder}
                                    name="mobile"
                                    value={data.mobile}
                                    onChange={handleOnChange}
                                    disabled={otpSent}
                                    className="w-full bg-transparent outline-none text-xl font-bold text-slate-700 placeholder:text-slate-300"
                                    maxLength={10}
                                />
                            </div>
                        </div>

                        {otpSent && (
                            <div className="flex flex-col gap-4 mt-4 animate-in fade-in slide-in-from-bottom-4 duration-500">
                                <label className="text-xs font-black uppercase tracking-[2px] text-slate-400 text-center">{t.otpVerification}</label>
                                <div className="flex justify-between gap-2 lg:gap-3">
                                    {data.otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            maxLength={1}
                                            value={digit}
                                            onChange={(e) => handleOtpChange(e.target, index)}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            className="w-full aspect-square text-center border-2 border-slate-100 rounded-2xl focus:border-[#00b259] focus:bg-white outline-none text-2xl font-black transition-all bg-slate-100/50 text-slate-700 shadow-sm"
                                        />
                                    ))}
                                </div>

                                <div className="flex justify-center mt-2">
                                    {canResend ? (
                                        <button type="button" onClick={handleSendOtp} className="text-[#00b259] font-black text-sm hover:underline">{t.resendOtp}</button>
                                    ) : (
                                        <p className="text-sm font-bold text-slate-400">{t.resendIn} <span className="text-[#143d2c]">{timer}s</span></p>
                                    )}
                                </div>
                            </div>
                        )}

                        <button className="bg-[#143d2c] hover:bg-[#00b259] text-white font-black py-5 rounded-[24px] shadow-xl shadow-green-900/10 hover:shadow-[#00b259]/20 transition-all text-lg uppercase tracking-[3px] mt-4 flex items-center justify-center gap-3">
                            {otpSent ? t.verifyLoginBtn : t.sendOtpBtn}
                        </button>

                        {otpSent && (
                            <button
                                type="button"
                                onClick={() => { setOtpSent(false); setData({ ...data, otp: new Array(4).fill("") }) }}
                                className="text-sm font-bold text-slate-400 hover:text-red-500 transition-colors mx-auto"
                            >
                                {t.wrongNumber} <span className="underline">{t.changeNumber}</span>
                            </button>
                        )}
                    </form>
                </div>
            </div>
        </section>
    )
}

export default Login
